// theme/theme.ts
import { createTheme, Theme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark'): Theme =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#ffa100',
      },
      secondary: {
        main: '#ed2020',
      },
      ...(mode === 'dark'
        ? {
            background: {
              default: '#121212',
              paper: '#1e1e1e',
            },
            text: {
              primary: '#ffffff',
              secondary: '#bbbbbb',
            },
          }
        : {
            background: {
              default: '#ffffff',
              paper: '#f8f8f8',
            },
            text: {
              primary: '#212529',
              secondary: '#4b5563',
            },
          }),
    },
    // ✅ UPDATE TYPOGRAPHY HERE
    typography: {
      fontFamily: "'Inter', sans-serif",
      // MUI default is 400. We change it to 500 (Medium).
      fontWeightRegular: 500, 
      fontWeightMedium: 600, // Optional: shift "Medium" var to SemiBold
      fontWeightBold: 700,
      
      // Optional: Ensure specific components inherit it nicely
      allVariants: {
        fontFamily: "'Inter', sans-serif",
      },
      button: {
        textTransform: 'none', // Optional: cleaner look with Inter
        fontWeight: 600,       // Buttons usually look better a bit bolder
      },
    },
  });